<!-- Component for display submission data loss (keeping it till CloudSync feature flag is off)  -->
<template>
	<PrecoaModal
		:open="modelValue"
		@update:open="(value) => emit('update:modelValue', value ?? false)"
		@submit="handleConfirm"
	>
		<template #default>
			<div class="flex flex-col items-center text-center">
				<ExclamationTriangleIcon
					class="mb-3 h-10 w-10"
					:class="hasUnsentOrFailed ? 'text-red-400' : 'text-yellow-400'"
				/>

				<h2 class="text-secondary-900 mb-2 text-lg font-semibold">
					{{
						hasUnsentOrFailed
							? t('auth.unsentDocumentsTitle')
							: t('auth.warningDeletesDataTitle', { event: t('auth.logout') })
					}}
				</h2>

				<p class="text-secondary-600 text-sm">
					{{
						hasUnsentOrFailed
							? t('auth.unsentDocumentsMessage')
							: t('auth.warningDeletesDataMessage')
					}}
				</p>

				<p
					class="mt-2 text-sm font-bold"
					:class="hasUnsentOrFailed ? 'text-red-500' : 'text-primary-800'"
				>
					{{ t('auth.cannotBeUndone') }}
				</p>
			</div>
		</template>

		<template #buttons>
			<FormKit
				type="button"
				@click="emit('update:modelValue', false)"
				:classes="{
					input: hasUnsentOrFailed
						? 'border border-accent-500 text-accent-500 bg-white hover:bg-accent-400 hover:text-accent-700 px-5 py-2 hover:border-accent-400 rounded-md font-bold w-full justify-center'
						: 'border px-5 py-2 rounded-md font-bold w-full justify-center',
				}"
			>
				{{ t('general.cancel') }}
			</FormKit>

			<FormKit
				type="submit"
				:classes="{
					input: hasUnsentOrFailed
						? 'bg-red-500 border border-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-md font-bold w-full justify-self-end justify-center'
						: 'border px-5 py-2 rounded-md font-bold w-full justify-self-end justify-center',
				}"
			>
				{{ t('auth.confirmActionAndDelete', { event: t('auth.logout') }) }}
			</FormKit>
		</template>
	</PrecoaModal>
</template>

<script setup lang="ts">
import PrecoaModal from '@/components/common/PrecoaModal.vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
	modelValue: boolean
	hasUnsentOrFailed: boolean
}>()

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void
	(e: 'confirm'): void
}>()

function handleConfirm() {
	emit('confirm')
	emit('update:modelValue', false)
}
</script>
